var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-container-card-annonce col-12 col-sm-12 col-md-6 col-lg-4",class:_vm.classWithConditions},[_c('div',{staticClass:"placeholder-card-annonce",class:{'placeholder-gradient': _vm.isGradient, 'placeholder-animated': _vm.isAnimated}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2977e092","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/PlaceholderCardAnnonce.vue
// module id = C/8w
// module chunks = 0